// extracted by mini-css-extract-plugin
module.exports = {"elSection":"Section_elSection__ibxti","vinWrapper":"Section_vinWrapper__2pfMa","warningModal":"Section_warningModal__xaCgs"};